import { Component, ElementRef, Inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuctionService } from '../../../../services/AuctionService';
import { Property } from '../../../../models/property';
import { firstValueFrom, take } from 'rxjs';
import { AppConfig } from '../../../../app.config';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoggingService } from '../../../../services/LoggingService';

declare let paypal: any;

@Component({ standalone: false,
  selector: 'authorization-dialog-paypal',
  templateUrl: 'authorization-dialog-paypal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['authorization-dialog-paypal.component.scss']
})
export class AuthorizationDialogPaypalComponent {
  @ViewChild('paymentRef', {static:true}) paymentRef!:ElementRef;
  @ViewChild('cardForm', {static:true}) cardForm!:ElementRef;
  @ViewChild('cardNameContainer ', {static:true}) cardNameContainer !:ElementRef;
  @ViewChild('cardNumberContainer', {static:true}) cardNumberContainer!:ElementRef;
  @ViewChild('cardExpiryContainer', {static:true}) cardExpiryContainer!:ElementRef;
  @ViewChild('cardCvvContainer', {static:true}) cardCvvContainer!:ElementRef;

  public title: string= "Credit Card Authorization";
  public confirmButtonText = "Authorize";
  public cancelButtonText = "Cancel";

  public busy:boolean=false;
  public paymentIntentId!:string;
  public paymentIntent?:string;
  public paypalMessage?: string;

  public property!:Property;

  public paymentIntentRegistered:boolean=false;
  public cardField:any;
  private paypalScript:boolean = false;
  private isFormValid:boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<AuthorizationDialogPaypalComponent>, private auctionService:AuctionService, private appConfig:AppConfig, private snackBar: MatSnackBar, private logger:LoggingService) {
    if(data){
      this.logger.log(data);
      this.property=data.property;
      this.paymentIntentId=data.paymentIntentId?data.paymentIntentId:undefined;
    }
  }

  ngOnInit(){
    setTimeout(() => { 
      if(!this.paypalScript) {
        this.addPaypalScript().then(()=> {
          this.cardField = paypal.CardFields({
            inputEvents: { onChange: (event:any)=> { this.isFormValid=event.isFormValid; }},
            createOrder: async () => {
              this.logger.log("Create order for: " + this.property.auction!.amountToAuthorize);
              this.busy=true;
              var r = await firstValueFrom(this.auctionService.createPaymentIntentPaypal(this.property.auction!.id, this.property.auction!.scheduleSeqNo!, this.property.auction!.amountToAuthorize!, this.property.header!).pipe(take(1)));
              this.logger.log("OrderId: "+ r.orderId);
              return r.orderId;
            },
            onApprove: async (data:any) => {
              this.logger.log("Approved: " + JSON.stringify(data));
              this.busy=true;
              this.paymentIntentId=data.orderID;
              this.paymentIntent=data.orderID;
              this.registerSuccessfulPaymentIntent();
            },
            onError: (data:any) => {
              //This error handler is a catch-all. Errors at this point are not expected to be handled beyond showing a generic error message or page.
              this.logger.log("Error: " + JSON.stringify(data));
              this.busy=false;
              this.paypalMessage="An error occured authorizing this payment. Please make sure you are using a valid card."
            }
          });
          if(this.cardField.isEligible()){
            const nameField = this.cardField.NameField({
              placeholder: "Full name as it appears on your card",
            });
            nameField.render(this.cardNameContainer.nativeElement);
            const numberField = this.cardField.NumberField();
            numberField.render(this.cardNumberContainer.nativeElement);
            const expiryField = this.cardField.ExpiryField();
            expiryField.render(this.cardExpiryContainer.nativeElement);
            const cvvField = this.cardField.CVVField();
            cvvField.render(this.cardCvvContainer.nativeElement);
            document.getElementById("cardFieldSubmitButton")!.addEventListener("click", () => {
              this.busy=true;
              this.cardField.submit().then(() => {
                // submit successful
              });
            });
          }
          /* NOT USING buttons right now
          paypal.Buttons({
            createOrder: (data, actions) => {
                return actions.order.create({
                    purchase_units: [{
                        amount: {
                            value: 100 // you can customize this value 
                        }
                    }]
                });
            },
            onApprove: (data, actions) => {
                return actions.order.capture().then( (details) => {
                    // Do something when payment is approved
                });
            }
          }).render(this.paymentRef.nativeElement);
          */
        });
      }
    }, 1);
  }

  private addPaypalScript(): any {
    this.paypalScript = true;
    return new Promise((resolve,reject)=>{
      let scriptTagElement = document.createElement('script');
      scriptTagElement.src= "https://www.paypal.com/sdk/js?client-id="+this.appConfig.getConfig("paypal_client_id")+"&components=card-fields&intent=authorize";
      scriptTagElement.onload = resolve;
      document.body.appendChild(scriptTagElement);
    });
  }

  get canSubmitCardData(){
    return this.isFormValid && !this.paymentIntentId && !this.busy;
  }

  public submitCardData(){
    this.paypalMessage=undefined;
    this.cardField.submit().then(() => {
      // submit successful
      this.logger.log("submit successful");
    });
  }

  get amountToAuthorize(){
    return this.property.auction!.amountToAuthorize;
  }

  private async registerSuccessfulPaymentIntent(){
    var r = await firstValueFrom(this.auctionService.authorizeForAuctionPaypal(this.property.auction!.id, this.property.auction!.scheduleSeqNo!, this.amountToAuthorize!, this.paymentIntentId, this.paymentIntent!, true, true).pipe(take(1)));
    if(r.success){
      this.paymentIntentRegistered=true;
      this.snackBar.open('Authorization successful.', '×', { panelClass: ['primary-snackbar'], verticalPosition: 'top', duration: 3000 });
      this.dialogRef.close(false);
    }
    else{
      this.paypalMessage="Server error please try again later.";
    }
    this.busy=false;
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  onOKClick(): void {
    this.dialogRef.close(false);
  }

}



